import React from 'react';
import { Center, Modal, Button, Text } from 'native-base';
const FlaggedAlready = _ref => {
  let {
    showFlagModal,
    setShowFlagModal
  } = _ref;
  return /*#__PURE__*/React.createElement(Center, null, /*#__PURE__*/React.createElement(Modal, {
    isOpen: showFlagModal,
    onClose: () => setShowFlagModal(false)
  }, /*#__PURE__*/React.createElement(Modal.CloseButton, null), /*#__PURE__*/React.createElement(Modal.Content, null, /*#__PURE__*/React.createElement(Modal.Header, null, "Notice"), /*#__PURE__*/React.createElement(Modal.Body, null, /*#__PURE__*/React.createElement(Text, null, "You have already flagged this post.")), /*#__PURE__*/React.createElement(Modal.Footer, {
    justifyContent: 'center'
  }, /*#__PURE__*/React.createElement(Button, {
    onPress: () => setShowFlagModal(false)
  }, "OK")))));
};
export default FlaggedAlready;
//# sourceMappingURL=FlaggedAlready.js.map